'use strict';

function fSliderUsp () {
    var slider = document.querySelector('.js-usp');
    var backgrounds = slider.querySelector('.js-usp-background');
    var buttons = Array.prototype.slice.call(slider.querySelectorAll('.js-usp-button'));
    var navIndicator = slider.querySelector('.js-usp-indicator');
    var textblocks = Array.prototype.slice.call(slider.querySelectorAll('.js-usp-text'));
    var currentTextblock = slider.querySelector('.usp__content__item.is-active');

    // Calculate height of slider
    if (window.innerWidth < 992) {
        let sliderWrapper = slider.querySelector('.usp__slider');

        if (sliderWrapper) sliderWrapper.style.height = (textblocks[0].offsetHeight + 40) + 'px';
    }

    var flickity = new Flickity(backgrounds, {
        cellAlign: 'left',
        draggable: true,
        contain: true,
        percentPosition: false,
        prevNextButtons: false
    });

    function fMoveIndicator (index) {
        navIndicator.style.left = (((index) * 10) * 2) + '%';
    }

    flickity.on('dragStart', function () {
        currentTextblock.classList.remove('is-active');
    });

    flickity.on('dragEnd', function () {
        var textblock = textblocks[flickity.selectedIndex];

        textblock.classList.add('is-active');
        currentTextblock = textblock;

        fMoveIndicator(flickity.selectedIndex);
    });

    flickity.on('change', function (index) {
        var textblock = textblocks[flickity.selectedIndex];

        currentTextblock.classList.remove('is-active');
        textblock.classList.add('is-active');
        currentTextblock = textblock;

        fMoveIndicator(index);
    });

    slider.addEventListener('click', function (event) {
        if (event.target.closest('.js-usp-button')) {
            var index = buttons.indexOf(event.target);
            var textblock = textblocks[index];
            
            currentTextblock.classList.remove('is-active');
            textblock.classList.add('is-active');
            
            currentTextblock = textblock;
            
            flickity.select(index);
        }
    });
}